import { DateTime } from 'luxon'

export function formatDistanceToNowShort(dateTime: DateTime) {
  const str = DateTime.now().diff(dateTime)
  if (Math.round(str.as('days')) > 20) return dateTime.toLocaleString()
  if (Math.round(str.as('days')) > 1) return `${Math.round(str.as('days'))}D`
  if (Math.round(str.as('hours')) > 1) return `${Math.round(str.as('hours'))}H`
  if (Math.round(str.as('minutes')) > 1)
    return `${Math.round(str.as('minutes'))}M`
}
